export default "/images/video-off.svg?34efe2271b33ca0378889333b65e86b5";